import { createSlice } from '@reduxjs/toolkit';
import {
	fetchToolLeads,
	fetchToolLeadConfig,
	fetchToolLeadDetail,
	exportToolLeads,
	deleteToolLead,
} from './Utils/ToolLeadUtils';

const initialFilters = {
	'filter[id]': '',
	'filter[tools_name]': '',
	'filter[name]': '',
	'filter[email]': '',
	'filter[whatsapp]': '',
	'filter[date_from]': '',
	'filter[date_to]': '',
	sort: '-updated_at',
	include: '',
	per_page: 15,
	page: 1,
};

const toolLeadSlice = createSlice({
	name: 'ToolLeads',
	initialState: {
		filters: initialFilters,
		data: {},
		detail: null,
		tools: [],
		selectedIds: [],
		isLoading: false,
		isDetailLoading: false,
		isExport: false,
		isConfigLoading: false,
	},
	reducers: {
		setFilters: (state, action) => {
			state.filters = action.payload;
		},
		resetFilters: (state) => {
			state.filters = initialFilters;
		},
		setDetail: (state, action) => {
			state.detail = action.payload;
		},
		clearDetail: (state) => {
			state.detail = null;
		},
		setSelectedIds: (state, action) => {
			state.selectedIds = action.payload;
		},
		toggleSelectedId: (state, action) => {
			const id = action.payload;
			if (state.selectedIds.includes(id)) {
				state.selectedIds = state.selectedIds.filter((item) => item !== id);
			} else {
				state.selectedIds = [...state.selectedIds, id];
			}
		},
		clearSelectedIds: (state) => {
			state.selectedIds = [];
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchToolLeads.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(fetchToolLeads.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchToolLeads.rejected, (state) => {
				state.isLoading = false;
			})
			.addCase(fetchToolLeadConfig.pending, (state) => {
				state.isConfigLoading = true;
			})
			.addCase(fetchToolLeadConfig.fulfilled, (state, action) => {
				state.isConfigLoading = false;
				state.tools = action.payload?.data?.tools ?? [];
			})
			.addCase(fetchToolLeadConfig.rejected, (state) => {
				state.isConfigLoading = false;
			})
			.addCase(fetchToolLeadDetail.pending, (state) => {
				state.isDetailLoading = true;
			})
			.addCase(fetchToolLeadDetail.fulfilled, (state, action) => {
				state.isDetailLoading = false;
				state.detail = action.payload?.data?.[0] ?? null;
			})
			.addCase(fetchToolLeadDetail.rejected, (state) => {
				state.isDetailLoading = false;
			})
			.addCase(exportToolLeads.pending, (state) => {
				state.isExport = true;
			})
			.addCase(exportToolLeads.fulfilled, (state) => {
				state.isExport = false;
			})
			.addCase(exportToolLeads.rejected, (state) => {
				state.isExport = false;
			})
			.addCase(deleteToolLead.fulfilled, (state) => {
				state.selectedIds = [];
			});
	},
});

export const {
	setFilters,
	resetFilters,
	setDetail,
	clearDetail,
	setSelectedIds,
	toggleSelectedId,
	clearSelectedIds,
} = toolLeadSlice.actions;

export { initialFilters };
export default toolLeadSlice.reducer;
